module.exports = __webpack_public_path__ + "img/Newbie_Sword_02_Warrior.8aadd694.png";